import { Award, BookOpen, Users } from "lucide-react";

const PERKS = [
  {
    icon: Award,
    title: "CPD Certificate",
    body: "An official CPD qualification on completion, recognising your hours of accredited professional development.",
  },
  {
    icon: BookOpen,
    title: "Full Protocol Manual",
    body: "The complete LymphoMetabolic sequence — visceral release, nodal drainage, pacing and pressure — yours to keep.",
  },
  {
    icon: Users,
    title: "Founder Mentorship",
    body: "Direct guidance from Elisabete during and after the course as you introduce the method to your own clients.",
  },
];

export const Graduates = () => (
  <section data-testid="graduates-section" className="py-24 bg-forest text-linen px-6 md:px-12">
    <div className="max-w-6xl mx-auto">
      <div className="max-w-2xl mb-14">
        <span className="font-monolbl text-xs uppercase tracking-[0.2em] text-mist font-semibold">
          The Founding Cohort
        </span>
        <h2 className="font-display text-3xl md:text-5xl tracking-tight mt-2 mb-5">
          Be among the first certified LymphoMetabolic practitioners.
        </h2>
        <p className="text-mist text-base leading-relaxed">
          Until now, the LymphoMetabolic method has only ever been practised by Elisabete
          herself. This course opens it to a small founding group of therapists and salons —
          trained directly by the person who created it.
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
        {PERKS.map((p) => (
          <div
            key={p.title}
            data-testid={`graduate-perk-${p.title.toLowerCase().replace(/ /g, "-")}`}
            className="rounded-2xl border border-white/15 bg-white/5 p-7 hover:bg-white/10 transition-colors"
          >
            <p.icon className="w-7 h-7 text-mist mb-4" />
            <h3 className="font-display text-xl mb-2">{p.title}</h3>
            <p className="text-sm text-mist leading-relaxed">{p.body}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);
